if ( typeof ReturnsPortal !== 'function' ) {

  class ReturnsPortal extends HTMLElement {

    connectedCallback() {

      this.modal = this.dataset.modal ? document.getElementById(this.dataset.modal) : null;
      this.trigger = this.querySelector('[data-js-returns-portal-trigger]');

      if ( this.trigger ) {
        this.trigger.addEventListener('click', event => {
          event.preventDefault();
          this.open();
        });
      }

      // The modal can also be closed by the close button, the backdrop or the
      // escape key, so the trigger state follows the modal instead of the click.
      if ( this.modal && this.trigger ) {
        this._modalObserver = new MutationObserver(() => {
          this.trigger.setAttribute('aria-expanded', this.modal.classList.contains(`${window.KT_PREFIX || ''}active`));
        });
        this._modalObserver.observe(this.modal, { attributes: true, attributeFilter: ['class'] });
      }

    }

    disconnectedCallback() {
      this._modalObserver?.disconnect();
    }

    // The portal is a third-party iframe, so it is only requested once the
    // customer actually opens the modal.
    loadFrame() {
      const frame = this.querySelector('[data-js-returns-portal-frame]');
      if ( ! frame || frame.getAttribute('src') ) {
        return;
      }
      frame.setAttribute('src', frame.dataset.src);
    }

    open() {
      if ( ! this.modal ) {
        return;
      }
      window.lastFocusedElm = this.trigger;
      this.loadFrame();
      this.modal.show();
    }

    close() {
      this.modal?.hide();
    }

  }

  if ( typeof customElements.get('returns-portal') == 'undefined' ) {
    customElements.define('returns-portal', ReturnsPortal);
  }

  // Shopify events

  document.addEventListener('shopify:section:select', e => {
    e.target.querySelector('returns-portal')?.open();
  });
  document.addEventListener('shopify:section:deselect', e => {
    e.target.querySelector('returns-portal')?.close();
  });

}
